// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2Hkj-","box":"WorkspacesBox_box__vfAeq","node":"WorkspacesBox_node__2A3dB"};